/**
 * Device Operations Timezone Cell - Frontend
 * @description Shows short timezone label (e.g. GMT-3) for the operation
 */

import React from 'react';
import { CellContext } from '@tanstack/react-table';
import { DashboardOperation } from '@/types/dashboard.types';
import { formatTimezoneShort } from '@/utils/formatters/timezoneFormatter';

export const DeviceOperationsTimezoneCell: React.FC<{
  info: CellContext<DashboardOperation, string | undefined>;
}> = ({ info }) => {
  const tz = info.getValue() ?? info.row.original.tz;
  return <div className="text-xs text-gray-600">{formatTimezoneShort(tz)}</div>;
};
